import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import SectionHeader from '../../shared/section-header';

import style from './index.module.scss';

class TakeQuestionsForm extends Component {
  state = {
    topic: '',
  };

  onChange = e =>
    this.setState({
      topic: e.target.value,
    });

  onSubmit = e => {
    e.preventDefault();

    const { topic } = this.state;
    const { closeModal } = this.props;

    if (topic) {
      console.log(topic);

      this.setState({
        topic: '',
      });

      closeModal();
    }
  };

  render() {
    const { topic } = this.state;
    const { currentUser } = this.props;
    const { form, img, input, list, button } = style;

    return (
      <form onSubmit={this.onSubmit} className={`row ${form}`}>
        <div className={`col-12 ${style['col--user']}`}>
          <Link to={`/profile/${currentUser.name}`}>
            <img
              src={currentUser.imgUrl}
              alt={currentUser.name}
              className={img}
            />
          </Link>
          <p className={style['requested-by']}>
            <Link
              to={`/profile/${currentUser.name}`}
              className={style['user-link']}
            >
              {currentUser.name}
            </Link>{' '}
            is taking questions on…
          </p>
        </div>
        <div className={`col-12 ${style['col--input']}`}>
          <input
            type="text"
            value={topic}
            placeholder="Enter Topic"
            onChange={this.onChange}
            className={`form-control ${input}`}
          />
          <p>...until Thu at 6pm.</p>
        </div>
        <SectionHeader headingLeft="About taking questions" colWidth={12} />
        <div className={`col-12 ${style['col--about']}`}>
          <ul className={list}>
            <li className={style['list-item']}>
              Specific subjects get the best questions.
            </li>
            <li className={style['list-item']}>
              Once you start, you will take questions for 24 hours or until you
              stop.
            </li>
            <li className={style['list-item']}>
              Your closest followers will be notified.
            </li>
          </ul>
        </div>
        <div className={`col-12 ${style['col--button']}`}>
          <button type="submit" className={`btn ${button}`}>
            Start
          </button>
        </div>
      </form>
    );
  }
}

TakeQuestionsForm.propTypes = {
  currentUser: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default TakeQuestionsForm;
